module.exports = fox._r("images/slides/urban/slide_2_5.jpg", __webpack_public_path__ + "images/slides/urban/slide_2_5.jpg");


//////////////////
// WEBPACK FOOTER
// ./images/slides/urban/slide_2_5.jpg
// module id = 58
// module chunks = 2